(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page-loader"] && !Shopify.designMode) return;
  try {
    (() => {
    const MIN_DURATION = 500; // tiempo mínimo que se ve la pantalla de carga antes de cambiar de página
    const MAX_WAIT = 10000; // si la página no cambia en este tiempo, la pantalla se quita sola
    let safetyTimer;

    const getLoader = () => document.querySelector('.page-loader');

    function hide() {
      clearTimeout(safetyTimer);
      getLoader()?.classList.remove('page-loader--visible');
    }

    function show() {
      const loader = getLoader();
      if (!loader) return;
      loader.classList.add('page-loader--visible');
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(hide, MAX_WAIT);
    }

    // Pide la página de destino por adelantado, para que abra al instante cuando termine la espera
    function prefetch(url) {
      const hint = document.createElement('link');
      hint.rel = 'prefetch';
      hint.href = url;
      document.head.append(hint);
    }

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented) return; // otro script ya manejó el clic (por ejemplo, al arrastrar el carrusel)

      const link = event.target.closest('a[href]');
      if (!link || !link.closest('[data-page-loader]')) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return; // otros sitios (WhatsApp…), tel: y mailto:
      if (url.pathname === location.pathname && url.search === location.search && link.href.includes('#')) return;

      // Muestra la pantalla de carga y cambia de página cuando se cumple el tiempo mínimo
      event.preventDefault();
      show();
      prefetch(url.href);
      setTimeout(() => location.assign(url.href), MIN_DURATION);
    });

    // Al salir de la página: solo se anima el cambio si se mostró la pantalla de carga
    window.addEventListener('pageswap', (event) => {
      const loaderVisible = getLoader()?.classList.contains('page-loader--visible');
      if (event.viewTransition && !loaderVisible) event.viewTransition.skipTransition();
    });

    // Al volver con "Atrás", el navegador puede restaurar la página con la pantalla visible
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) hide();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
